import { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ImportDialog } from "@/components/app/ImportDialog";

export function AccessImportButton({ onDone }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="access-import-btn"><FileSpreadsheet className="h-4 w-4 mr-1" />Excel upload</Button>
      <ImportDialog entity="access" open={open} onOpenChange={setOpen} onDone={onDone} path="/admin/access-workbook/import" commitLabel="Apply"
        title="Users, roles and permissions — Excel upload" templatePath="/admin/access-workbook" templateName="TESSOL_Users_Roles_Permissions.xlsx"
        templateLabel="Download current workbook"
        hint="Download the workbook (it has your current users, roles and permission grid), edit it and upload it back. Only filled cells change anything; users not in the sheet are left as they are." />
    </>
  );
}
